import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'blewm-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Blewm',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 833-932-5396,
  email: 'support@blewm.com',
  poweredByLogo: true,
};

export default config;


// WEBPACK FOOTER //
// ./src/whitelabel/configs/blewm/index.js